import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
// import moment from "moment";
import AutoQuery from "servicestack/auto-query/auto-query";
import RetrieveTokenInfo from "emun.order/retrieve-token-info";
import RetrieveTokenExInfo from "emun.order/retrieve-tokenex-info";
import RetrieveHostedPCIInfo from "emun.order/retrieve-hostedpci-info";

export default class VendorFileDetailsController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.config = $ctrl.cartConfig = cartConfig;
		//console.info("BL*** options = " + JSON.stringify(options));
		$ctrl.exportId = options.exportId;
		$ctrl.title = options.title || "Order Batch Details";
	}
	$onInit() {
		const $ctrl = this;
        $ctrl.bus.read('QueryOrdersJoin.json?ExportId=' + $ctrl.exportId).then(res=> {
            $ctrl.orders = res.data.results;
        });
	}
	retrieveTokenInfo(token, cvv) {
		let $ctrl = this;
		return RetrieveTokenInfo({ token: token, cvv: cvv });
	  }
	retrieveTokenExInfo(token, expiration, cvv) {
		let $ctrl = this;
		return RetrieveTokenExInfo({ token: token, expiration: expiration, cvv: cvv });
	}
	retrieveHostedPCIInfo(order) {
		let $ctrl = this;
		return RetrieveHostedPCIInfo({ 
			token: order.paymentMethodToken, 
			tokenizationCode: order.tokenizationCode,
			expiration: order.paymentMethodExpiration, 
			type: order.paymentMethodType, 
			name: order.paymentMethodName, 
			lastFour: order.paymentMethodLastFour 
		});
	}
}
